import api from './api';

export const getStateProvincesApi = (params) => api().get('/state-province', { params });
export const addNewStateProvinceApi = (data) => api().post('/state-province', data);
export const deleteStateProvincesApi = (params) => api().delete('/state-province', { params });
export const updateStateProvincesApi = (params) => api().put(`/state-province/${params.id}`, params.values);
